module.exports = __webpack_public_path__ + "static/media/templeGPS.d118c5f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templeGPS.svg
// module id = 360
// module chunks = 0